import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import Img from 'react-image';
import { WINDOW, ROUTES, metricMinusPercent } from 'utils/utils';
import { onPortalTypeChange } from 'services/appService';
import { FORM, getDefaultValue } from 'utils/formUtils';
import { REST } from 'utils/reqUtils';
import { APP } from 'actions/appActions';
import { Row, Col, Menu, Dropdown, Button, Icon, Radio, notification } from 'antd';
import AfspLogin from 'components/AfspLogin';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { setEnvPrefix } = ssCommonUtils;

var
headerWidth = 0,
headerHeight = 0;

export default withRouter(class AfspHeader extends Component {
    constructor(props) {
        super(props);
        const { state } = this.props;
        this.getTitle = this.getTitle.bind(this);
        this.getControls = this.getControls.bind(this);
        this.getButton = this.getButton.bind(this);
        this.handlePortalChange = this.handlePortalChange.bind(this);
        //this.getPortalReg = this.getPortalReg.bind(this);
        this.incrementLoginAttempt = this.incrementLoginAttempt.bind(this);

        this.state = {
            modal: {
                visible: false,
                view: 'login',
                loginAttempts: 0
            }
        }

        this.controls = {
            modal: {
                resetDisplay: () => {
                    const
                    { state } = this.props,
                    { home } = this.props.state.request,
                    { setData } = this.props.services,
                    { USER_ID, PASSWORD } = FORM.TYPES,
                    { REQUEST } = APP,
                    { HOME } = REQUEST,
                    { SUCCESS, FAILURE } = REST.STATUS;

                    let { modal } = this.state,
                    req = home[modal.view];

                    switch(modal.view) {
                        case 'login':
                            switch(req.status) {
                                // Will reset for both 'SUCCESS' and 'FAILURE'.
                                case SUCCESS:
                                case FAILURE:
                                    setData(HOME.LOGIN.RESET);
                                    setData('login', {...state.login.login,
                                        userId: {...state.login.login.userId,
                                            valid: false,
                                            value: getDefaultValue(USER_ID)
                                        },
                                        password: {...state.login.login.password,
                                            valid: false,
                                            value: getDefaultValue(PASSWORD)
                                        }
                                    });
                                    if(req.status === FAILURE) {
                                        this.incrementLoginAttempt();
                                        // notification.open({
                                        //     message: 'Login Notice: FAILED',
                                        //     description:
                                        //         'A failed login attempt was made. Multiple failed attempts will result ' +
                                        //         'in an account lock-out.',
                                        //     icon: <Icon type="info-circle-o" style={{ color: '#B7B700' }}/>,
                                        //     duration: 0
                                        // });
                                    }
                                    break;
                            }
                            break;

                        case 'forgot':
                            switch(req.status) {
                                case SUCCESS:
                                case FAILURE:
                                    setData(HOME.FORGOT.RESET);
                                    setData('forgotten', {...state.login.forgotten,
                                        userId: {...state.login.forgotten.userId,
                                            valid: false,
                                            value: getDefaultValue(USER_ID)
                                        },
                                        captcha: {...state.login.forgotten.captcha,
                                            valid: false,
                                            value: getDefaultValue(USER_ID)
                                        }
                                    });
                                    if(req.status === FAILURE) {
                                        notification.open({
                                            message:
                                                'Password Reset Request: FAILED', description: 'The request for a password ' +
                                                'reset has failed. Please contact the help desk if you continue to experience ' +
                                                'this error.',
                                            icon: <Icon type="warning" style={{ color: '#D80000' }}/>,
                                            duration: 0
                                        });
                                    }
                                    break;
                            }
                            break;
                            case 'changeEmail':
                                switch(req.status) {
                                    case SUCCESS:
                                    case FAILURE:
                                        setData(HOME.FORGOT.RESET);
                                        setData('changeEmail', {...state.login.changeEmail,
                                            userId: {...state.login.changeEmail.userId,
                                                valid: false,
                                                value: getDefaultValue(USER_ID)
                                            },
                                            captcha: {...state.login.changeEmail.captcha,
                                                valid: false,
                                                value: getDefaultValue(USER_ID)
                                            }
                                        });
                                        if(req.status === FAILURE) {
                                            notification.open({
                                                message:
                                                    'Change Email Request: FAILED', description: 'The request for a change ' +
                                                    'email has failed. Please contact the help desk if you continue to experience ' +
                                                    'this error.',
                                                icon: <Icon type="warning" style={{ color: '#D80000' }}/>,
                                                duration: 0
                                            });
                                        }
                                        break;
                                }
                                break;
                    }

                    if(modal.view !== 'login')
                        this.setState({...state, modal: {...modal, view: 'login' }});
                },
                handleDisplay: () => {
                    let { modal } = this.state, { visible } = modal;
                    this.setState({...state, modal: {...modal, visible: !visible }});
                },
                changeModal: (view) => {
                    let { modal } = this.state;
                    this.setState({...state, modal: {...modal, view: view }});
                }
            }
        }

        // Bind everything in 'controls'. You can't bind "this.controls" because they
        // are not methods, therefore you have to bind each method. This loop should
        // handle that regardless of how many methods there are.
        for (var p in this.controls)
            for (var f in this.controls[p])
                this.controls[p][f] = this.controls[p][f].bind(this);
    }

    incrementLoginAttempt() {
        const {modal} = this.state;
        this.setState({...this.state, modal: {...modal,
            loginAttempts: (modal.loginAttempts + 1)
        }});
    }

    logoStyle(type) {
        let height, width;

        const
        { DESKTOP_MENU, MOBILE_MENU } = WINDOW,
        { win } = this.props;

        switch(type) {
            case DESKTOP_MENU:
                height = 94,
                width = Math.round((height * 1.02));
                return {
                    src: setEnvPrefix('/home/images/dhs-logo-01.png'),
                    style: {
                        height: height,
                        width: width
                    }
                };
            case MOBILE_MENU:
                height = metricMinusPercent(win.height, 0.92),
                width = Math.round((height * 1.02));
                return {
                    src: setEnvPrefix('/home/images/dhs-logo-01.png'),
                    style: {
                        height: height,
                        width: width,
                        marginTop: metricMinusPercent(win.height, 0.985),
                        marginLeft: metricMinusPercent(win.height, 0.975)
                    }
                };
        }
    }

    getTitle(type) {
        const {width, height, displayType} = this.props.win;
        switch(type) {
            case 'afsp-home':
                if(displayType === 'desktop')
                    return (<div>
                        <div style={{
                            color: 'white',
                            height: '47px',
                            width: '100%',
                            textAlign: 'center',
                            fontFamily: 'Arial',
                            fontSize: '22px'
                        }}>
                            <Link to={ROUTES.ROOT} style={{color:'white'}}>
                                <b>{'Flight Training Security Program (FTSP)'}</b>
                            </Link>
                        </div>
                        <div style={{
                            color: 'white',
                            height: '47px',
                            width: '100%',
                            textAlign: 'center',
                            fontFamily: 'Arial',
                            fontSize: '20px'
                        }}>
                            <span style={{
                                position: 'absolute',
                                height: '100%',
                                width: '100%',
                                left: '0px',
                                top: '30px'
                            }}>
                                <i><a style={{ color:'white' }} href="http://www.dhs.gov" target="_blank">
                                    {'Department of Homeland Security'}
                                </a></i>
                            </span>
                        </div>
                    </div>)
                else if(displayType === 'mobile') {
                    return (<div style={{
                            color: 'white',
                            width: '100%',
                            display: 'block',
                            textAlign: 'center',
                            fontFamily: 'Arial',
                            marginTop: '-75px'
                        }}>
                        <div style={{ fontSize: '60px' }}>
                            <Link to={ROUTES.ROOT} style={{color:'white'}}>
                                <b>{'FTSP'}</b>
                            </Link>
                        </div>
                        <div style={{ fontSize: '30px', marginTop: '-10px' }}>
                            <i><a style={{color:'white'}} href="http://www.dhs.gov" target="_blank">
                                {'Department of Homeland Security'}
                            </a></i>
                        </div>
                    </div>);
                }

        }
    }

    getButton(type, props, buttonEvents) {
        var
        events = {},
        populateEvents = (eventArray) => {
            for (var i = 0; i < eventArray.length; i++)
                events[eventArray[i][0]] = eventArray[i][1];

            for (var p in events)
                if(!props.hasOwnProperty(p))
                    props[p] = events[p];
        };

        switch(type) {
            case 'register':
                if(buttonEvents != null)
                    if(buttonEvents.hasOwnProperty('register'))
                        populateEvents(buttonEvents.register);

                return (<Button {...props}>{'Register'}</Button>);

            case 'home':
                if(buttonEvents != null)
                    if(buttonEvents.hasOwnProperty('home'))
                        populateEvents(buttonEvents.home);

                return (<Button {...props}>{'Home'}</Button>);
        }
    }

    handlePortalChange = e => onPortalTypeChange(e.target.value);

    getControls(type, buttonEvents) {
        const
        { win, services, state } = this.props,
        { portalType } = state,
        { ROOT, HOME } = ROUTES,
        { modal } = this.state,
        { displayType } = win,
        { controls } = this;

        let afspLoginConfig = {};
        switch(type) {
            case 'login':
                afspLoginConfig = {
                    win,
                    state,
                    modal,
                    services,
                    sref: 'login',
                    controls: controls.modal,
                    captcha: this.props.captcha
                };

                if(displayType === 'desktop')
                    return (
                        <div>
                            <Row>
                                <Col span={16} style={{ textAlign: 'right' }}>
                                    <div style={{ height: '47px' }}>
                                        <span style={{ position: 'relative', top: '-8px' }}>
                                            <AfspLogin {...afspLoginConfig}/>
                                        </span>
                                    </div>
                                    <div style={{ height: '47px' }}>
                                        <span style={{ position: 'relative', top: '-8px' }}>
                                            <Link to={portalType === 'PROVIDER' ? HOME.PROVIDER_REGISTRATION : HOME.CANDIDATE_REGISTRATION}>{
                                                this.getButton('register', {
                                                    type: 'default',
                                                    icon: 'user-add',
                                                    style: { width: '170px' }
                                                }, buttonEvents)
                                            }</Link>
                                        </span>
                                    </div>
                                </Col>
                                <Col span={8} style={{ height: '94px', left: '10px' }}>
                                    <div>
                                        <Radio.Group
                                            style={{ position: 'relative' }}
                                            value={state.portalType}
                                            onChange={this.handlePortalChange}
                                        >
                                            <div style={{ height: '47px', display: 'table' }}>
                                                <span style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                                                    <Radio style={{ display: 'block', color: 'white' }} value="CANDIDATE">
                                                        {'Candidate Portal'}
                                                    </Radio>
                                                </span>
                                            </div>
                                            <div style={{ height: '47px', display: 'table' }}>
                                                <span style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                                                    <Radio style={{ display: 'block', color: 'white' }} value="PROVIDER">
                                                        {'Provider Portal'}
                                                    </Radio>
                                                </span>
                                            </div>
                                        </Radio.Group>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    );
                else if(displayType === 'mobile')
                    return (
                        <div style={{
                            marginTop: `-${metricMinusPercent(headerHeight, 0.36)}px`,
                            marginRight: `${metricMinusPercent(headerWidth, 0.95)}px`
                        }}>
                            <div style={{
                                background: 'rgb(0, 69, 137)',
                                textAlign: 'right',
                                fontSize: metricMinusPercent(headerWidth, 0.9) + 'px',
                                height: metricMinusPercent(headerWidth, 0.92) + 'px'
                            }}>
                                <a href='#'><Icon style={{ color: 'white' }} type="bars"/></a>
                            </div>
                        </div>
                    );
                    break;
            case 'user':
                if(displayType === 'desktop')
                    return (
                        <div>
                            <Row style={{
                                    textAlign: 'right',
                                    marginTop: '7px'
                                }}>
                                <Col span={24}>
                                    <Dropdown
                                        placement="bottomRight"
                                        overlay={(
                                            <Menu>
                                                <Menu.Item>{'Log Out'}</Menu.Item>
                                            </Menu>
                                        )}
                                    >
                                        <Img src={setEnvPrefix('/home/images/user-icon-01.png')} style={{
                                            width: '80px',
                                            height: '80px'
                                        }}/>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </div>
                    );
                else if(displayType === 'mobile') return (<div>{'NONE'}</div>);
                break;
            case 'home':
                if(displayType === 'desktop')
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ height: '94px' }}>
                                <span style={{ position: 'relative', top: '16px' }}>
                                    <Link to={ROOT}>{
                                        this.getButton('home', {
                                            type: 'primary',
                                            icon: 'home',
                                            style: { width: '170px' }
                                        }, buttonEvents)
                                    }</Link>
                                </span>
                            </div>
                        </div>
                    );
                else if(displayType === 'mobile') return (<div>{'NONE'}</div>);
                break;
            // Login, Register, Home
            case 'lrh':
                afspLoginConfig = {
                    sref: 'login',
                    styler: 'lrh',
                    state: state,
                    modal: modal,
                    services: services,
                    controls: controls.modal,
                    win: win
                };

                if(displayType === 'desktop')
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ height: '32px' }}>
                                <span style={{ position: 'relative', top: '-15px' }}>
                                    <AfspLogin {...afspLoginConfig}/>
                                </span>
                            </div>
                            <div style={{ height: '31px' }}>
                                <span style={{ position: 'relative', top: '-16px' }}>
                                    <Link to={HOME.REGISTER}>{
                                        this.getButton('register', {
                                            type: 'default',
                                            icon: 'user-add',
                                            style: {
                                                width: '170px',
                                                height: '22px'
                                            }
                                        }, buttonEvents)
                                    }</Link>
                                </span>
                            </div>
                            <div style={{ height: '31px' }}>
                                <span style={{position: 'relative', top: '-16px'}}>
                                    <Link to={ROOT}>{
                                        this.getButton('home', {
                                            type: 'default',
                                            icon: 'home',
                                            style: {
                                                width: '170px',
                                                height: '22px'
                                            }
                                        }, buttonEvents)
                                    }</Link>
                                </span>
                            </div>
                        </div>
                    );
                else if(displayType === 'mobile') return (<div>{'NONE'}</div>);
                break;
            case 'lh':
                afspLoginConfig = {
                    sref: 'login',
                    state: state,
                    modal: modal,
                    services: services,
                    controls: controls.modal,
                    win: win
                };

                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ height: '47px' }}>
                            <span style={{ position: 'relative', top: '-8px' }}>
                                <AfspLogin {...afspLoginConfig}/>
                            </span>
                        </div>
                        <div style={{ height: '47px' }}>
                            <span style={{ position: 'relative', top: '-8px'}}>
                                <Link to={ROOT}>{
                                    this.getButton('home', {
                                        type: 'default',
                                        icon: 'home',
                                        style: { width: '170px' }
                                    }, buttonEvents)
                                }</Link>
                            </span>
                        </div>
                    </div>
                );

            default: return (<div>{'NO DEFAULT'}</div>);
        }
    }

    render() {
        let { win, config, state } = this.props,
        { height, width, displayType } = win,
        { DESKTOP_MENU, MOBILE_MENU } = WINDOW,
        { ROOT, HOME } = ROUTES;

        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            left: '4px',
            color: 'white',
            fontSize: '14px',
            fontFamily: 'Arial'
        };

        if(config == null) config = { type: 'login' };

        switch(displayType) {
            case DESKTOP_MENU:
                return (
                    <div style={{ marginTop: '10px' }}>
                        <Row>
                            <Col span={8}>
                                <Row>
                                    <a style={{ color:'white' }} href="http://www.tsa.gov" target="_blank">
                                        <Col>
                                            <Img {...this.logoStyle(displayType)}/>
                                        </Col>
                                        <Col>
                                            <div style={{
                                                top: '-10px',
                                                left: '114px',
                                                color: 'white',
                                                fontSize: '24px',
                                                fontFamily: 'Arial',
                                                position: 'absolute'
                                            }}>
                                                <div style={{ height: '26px' }}>{'Transportation'}</div>
                                                <div style={{ height: '26px' }}>{'Security'}</div>
                                                <div style={{ height: '26px' }}>{'Administration'}</div>
                                            </div>
                                        </Col>
                                    </a>
                                </Row>
                            </Col>
                            <Col span={8}>{this.getTitle(config.title)}</Col>
                            <Col span={8}>{this.getControls(config.type, config.buttonEvents)}</Col>
                        </Row>
                    </div>
                );

            case MOBILE_MENU:
                headerWidth = win.width;
                headerHeight = metricMinusPercent(win.height, 0.89);
                return (
                    <div style={{
                        background: 'rgb(0, 69, 137)',
                        height: metricMinusPercent(win.height, 0.89) + 'px',
                        width: headerWidth + 'px',
                        marginLeft: '-50px'
                    }}>
                        <Row>
                            <Img {...this.logoStyle(displayType)}/>
                            <Col>{this.getControls(config.type)}</Col>
                        </Row>
                        <Row>
                            <Col>{this.getTitle(config.title)}</Col>
                        </Row>
                    </div>
                );
        }
    }
});
